import { createActionNamespace } from 'Modules/core/redux';

import { SendCode, SubmitFeedbackForm, SetCodeSendTime, SendFeedbackForm } from './types';


const feedbackAction = createActionNamespace('feedback');

export const feedbackActions = {
    submitForm: feedbackAction<SubmitFeedbackForm>('SUBMIT_FORM'),
    sendCode: feedbackAction<SendCode>('SEND_CODE'),
    sendForm: feedbackAction<SendFeedbackForm>('SEND_FORM'),
    setCodeSendTime: feedbackAction<SetCodeSendTime>('SET_CODE_SEND_TIME'),
    setBusy: feedbackAction<boolean>('SET_BUSY'),
};
